
import ShopUser from './Users/shops/shop-user';
customElements.define('shop-user', ShopUser,{extends: 'a'});

import DeleteShopUser from './Users/shops/delete-shop-user';
customElements.define('delete-shop-user', DeleteShopUser,{extends: 'a'});

import ShopSchedule from './Shops/shop-schedule';
customElements.define('shop-schedule', ShopSchedule,{extends: 'div'});

import PasswordReset from './Users/index';
customElements.define('password-reset', PasswordReset,{extends: 'a'});

import AddressesForm from './Addresses/form';
customElements.define('core-address-form', AddressesForm,{extends: 'div'});


import NotificationHeaderItem from './Notifications/notification-header-item';
customElements.define('core-notification-header-item', NotificationHeaderItem,{extends: 'div'});

import NotificationIndex from './Notifications/notifications-index';
customElements.define('core-notifications-index', NotificationIndex,{extends: 'div'});
